'use client';

import { BaseTranslations } from '../../../../baseTranslations';
import { RichText } from '../../../../components/RichText';
import { useCmsClientContext } from '../../../../utils/cmsPageContext';
import { getClientTranslations } from '../../../../utils/translations/getClientTranslations';
import { tr } from '../../../../utils/translations/tr';
import { MaterialIcon } from '../../../MaterialIcon';
import { ProductDetailsAttributeGroups } from '../../BaseComponents/ProductDetailsAttributeGroups';
import { ProductDetailsSectionHeader } from '../../BaseComponents/ProductDetailsSectionHeader';
import { ProductDetailsSectionWrapper } from '../../BaseComponents/ProductDetailsSectionWrapper';
import { hasLongDescription } from '../../utils/sectionVisibility/sectionVisibility';
import type { ConfiguredSectionProps } from './types';

/**
 * Highlights is the second slot with a fixed part: the configured groups (Quick Facts, Things to
 * consider, … — list rows with their brand icons) come first, then the product's `long_description`
 * as the "About this product" accordion, exactly where the default Highlights section renders it.
 */
export const ProductDetailsSectionConfiguredHighlights: React.FC<
  ConfiguredSectionProps
> = (section) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(BaseTranslations, context);
  const { product, pushDataLayer, label } = section;

  return (
    <div
      className="flex flex-col gap-6"
      data-component="pdp-configured-highlights"
    >
      <ProductDetailsSectionHeader
        icon={<MaterialIcon icon={section.icon} size={3} />}
      >
        {label}
      </ProductDetailsSectionHeader>
      <ProductDetailsAttributeGroups
        groups={section.groups}
        sectionTitle={label}
        product={product}
        pushDataLayer={pushDataLayer}
      />
      {hasLongDescription(product) && (
        <ProductDetailsSectionWrapper
          dropdownSection={true}
          title={tr('about_this_product', staticText)}
          sectionTitle={label}
          product={product}
          pushDataLayer={pushDataLayer}
        >
          <div className="py-spacing/padding/y px-spacing/padding/x flex flex-col gap-spacing/gap/x">
            <RichText>{product?.long_description}</RichText>
          </div>
        </ProductDetailsSectionWrapper>
      )}
    </div>
  );
};
